import NBType from '@netbase/nb-type'

/**
 * @typedef {object} PayloadSchema
 * @property {boolean} fromInsightAPI
 * @property {boolean} requireConcept
 * @property {boolean} requireCount
 * @property {boolean} requireExternalConcept
 * @property {boolean} requireHighlight
 * @property {boolean} requireSentiment
 * @property {boolean} sentenceObjectDescendantRequiredOnly
 */
const PayloadSchema = NBType.object().shape('PayloadSchema', {
  /* @prop */
  fromInsightAPI: NBType.boolean(),
  /* @prop */
  requireConcept: NBType.boolean(),
  /* @prop */
  requireCount: NBType.boolean(),
  /* @prop */
  requireExternalConcept: NBType.boolean(),
  /* @prop */
  requireHighlight: NBType.boolean(),
  /* @prop */
  requireSentiment: NBType.boolean(),
  /* @prop */
  sentenceObjectDescendantRequiredOnly: NBType.boolean()
  /* END */
})
export default PayloadSchema
// RESERVE BELOW
